import {AbstractTransition} from './AbstractTransition';
import {AbstractAnimation} from '../animations/AbstractAnimation';
import {GroupAnimation} from '../animations/GroupAnimation';

class GroupTransition extends AbstractTransition {

    public create(...animations:AbstractAnimation[]) {
        this.animation=new GroupAnimation(...animations);
        return this;
    }

}

export {};